import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-advertising',
  imports: [],
  templateUrl: './advertising.component.html',
  styleUrl: './advertising.component.scss'
})
export class AdvertisingComponent {
  bannerImageUrl = this.getBannerImageUrl();
  externalUrl = environment.advertisementExternalUrl;
  private getBannerImageUrl(): string {
    // environmentからベースURLを取得
    const advertisementImgUrl = environment.advertisementImgUrl;
    return advertisementImgUrl;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onImageError(event: any): void {
    console.warn('画像の読み込みに失敗しました:', event.target.src);
    event.target.style.display = 'none';
  }
}
